import produce from 'immer';

const changeFormValue: any = (value: any, dataKey: any, error: any, data: any, errors: any, options: any) => {
    const returnObjects: Record<string, any> = {};
    const { errorKey } = options || {};
    returnObjects.errors = produce(errors, (draft: any) => {
        if (error) {
            draft[errorKey || dataKey] = true;
        } else {
            delete draft[errorKey || dataKey];
        }
    });

    returnObjects.data = produce(data, (draft: any) => {
        draft[dataKey] = value;
    });

    if (returnObjects.errors === errors) {
        delete returnObjects.errors;
    }

    return returnObjects;
};
export default changeFormValue;
